import { Component, inject } from '@angular/core';
import { AuthService } from 'src/app/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-back-to-signin',
  templateUrl: './back-to-signin.component.html',
  styleUrls: ['./back-to-signin.component.scss'],
})
export class BackToSigninComponent {
  private _auth: AuthService = inject(AuthService);

  public logout() {
    this._auth.logout().pipe(untilDestroyed(this)).subscribe();
  }
}
